import { lazy } from 'react'

import type { NavigationRoutesFn } from 'modules/core/lib/react-router'

const TalentPage = lazy(
  () => import('modules/performance_analytics/pages/employees/TalentPage')
)

const RootPage = lazy(() => import('modules/performance_analytics/pages/employees/RootPage'))

const employeesRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.employees.id.talent.path,
      element: <RootPage />,
      children: [
        {
          index: true,
          element: <TalentPage />,
        },
      ],
    },
  ]
}

export default employeesRoutes
